import {statusTypes} from '@/core/constants'

export default {
    defaultObject: {
        status: statusTypes.ACTIVATED,
        quantityDecimalPlacesValue: 2,
        quantityDecimalPlacesAmount: 2
    }
}
